import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadphonesSimple, faDollarSign, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import Price from 'Components/Utility/Price/Price';

function BundleFallbackPoints({
  maxPrice,
  validDrm,
  totalGameCount,
}) {
  return (
    <div className="BundlePoints BundlePoints--fallback">
      <div className="BundlePoints__points container">
        <div className="BundlePoints__point">
          <div className="BundlePoints__dollarIcon BundlePoints__icon">
            <FontAwesomeIcon icon={faDollarSign} />
          </div>
          <div className="BundlePoints__pointText">
            <FormattedMessage id="fall-back-bar.best-ever" defaultMessage="Get best ever savings on" />&nbsp;
            <Price
              price={maxPrice}
            />&#8200;
            <FormattedMessage
              id="fall-back-bar.winning-software"
              defaultMessage="worth of products"
            />
          </div>
        </div>
        {totalGameCount > 0 &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faHeadphonesSimple} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="fall-back-bar.keys-total"
                defaultMessage="{totalGameCount} Individual keys delivered"
                values={{
                  totalGameCount,
                }}
              />
            </div>
          </div>
        }
        {!isEmpty(validDrm) && validDrm[0] === 'drm_free' &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faCircleCheck} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="fall-back-bar.point.redeem.drm-free"
                defaultMessage="DRM Free downloads"
              />
            </div>
          </div>
        }
        {isEmpty(validDrm) &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faCircleCheck} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="fall-back-bar.point.redeem-keys"
                defaultMessage="Redeem via publisher website"
              />
            </div>
          </div>
        }
      </div>
    </div>
  );
}

BundleFallbackPoints.propTypes = {
  maxPrice: PropTypes.shape({}),
  totalGameCount: PropTypes.bool,
  validDrm: PropTypes.arrayOf(PropTypes.string),
};

BundleFallbackPoints.defaultProps = {
  maxPrice: {},
  totalGameCount: 0,
  validDrm: [],
};

const mapStateToProps = ({
  siteTheme,
}) => ({
  siteTheme,
});

export default connect(mapStateToProps)(BundleFallbackPoints);
